export default "__VITE_ASSET__CkaiSvKz__"